import * as React from 'react'
import { NextPage } from 'next'
import { Partner } from '../../../types'

import PartnerFooter from '../Footer'
import PartnerHeader from '../Header'
import PartnerMeta from '../Meta'

type PartnerLayoutProps = {
  partner: Partner
  children: React.ReactNode
}

const PartnerLayout: NextPage<PartnerLayoutProps> = ({ partner, children }) => (
  <>
    <PartnerMeta partner={partner} />
    <PartnerHeader partner={partner} />
    {children}
    <PartnerFooter partner={partner} />
  </>
)

export default PartnerLayout
